import React, { useEffect, useState, useRef, useCallback } from "react";
import { ArrowLeft, ArrowDownLeft, ArrowUpRight, Smartphone, Building2, Home, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerData } from "@/redux/slices/customerSlice";
import { getT } from "@/i18n/translations";


const PAGE_SIZE = 10;

const RedeemCash = () => {
    const t = getT();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data: customer, loading } = useSelector((state) => state.customer);

    const [activeTab, setActiveTab] = useState("earned");
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
    const loaderRef = useRef(null);

    useEffect(() => {
        const customerCode = localStorage.getItem("customercode");
        if (!customer) dispatch(fetchCustomerData(customerCode));
    }, []);

    useEffect(() => {
        setVisibleCount(PAGE_SIZE);
    }, [activeTab]);

    const transactions =
        customer?.activityLogs
            ?.filter((item) => item?.valueType) // validate valueType exists
            ?.map((item) => ({
                id: item.id,
                code: item.voucherCode,
                amount: item.value,
                type: item.transactionType,
                valueType: item.valueType,
                action: item.action,
                date: item.activityDateTime,
                description: item.description,
            }))
            ?.sort((a, b) => new Date(b.date) - new Date(a.date)) || [];
    console.log(transactions, customer)
    const visibleTxs = transactions.slice(0, visibleCount);
    const hasMore = visibleCount < transactions.length;


    const handleObserver = useCallback((entries) => {
        if (entries[0].isIntersecting && hasMore) {
            setVisibleCount(prev => prev + PAGE_SIZE);
        }
    }, [hasMore]);

    useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, { threshold: 0.1 });
        if (loaderRef.current) observer.observe(loaderRef.current);
        return () => observer.disconnect();
    }, [handleObserver]);

    return (
        <div
            className="min-h-screen flex flex-col items-center"
            style={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "#fff5f5",
                backgroundImage:
                    "radial-gradient(circle, #ffd6d6 1px, transparent 1px)",
                backgroundSize: "22px 22px",
            }}
        >
            <div className="w-full max-w-md min-h-screen flex flex-col bg-[#ffe5e5]">

                {/* LOADER */}
                {loading && (
                    <div className="fixed inset-0 bg-black/30 flex justify-center items-center z-50 backdrop-blur-sm">
                        <Loader2 className="animate-spin h-10 w-10 text-[#e60012]" />
                    </div>
                )}

                {/* HEADER */}
                <div className="relative flex items-center justify-center px-4 py-4 mt-2 ">
                    <button
                        onClick={() => navigate(-1)}
                        className="absolute left-4 w-9 h-9 flex items-center justify-center rounded-full bg-red-50 shadow-sm border border-red-100"
                    >
                        <ArrowLeft className="w-5 h-5 text-[#e60012]" />
                    </button>

                    <p className="text-[15px] font-bold text-[#e60012] tracking-wide">
                        {t.redeem_pageTitle}
                    </p>

                    <button
                        onClick={() => navigate("/home")}
                        className="absolute right-4 w-9 h-9 flex items-center justify-center rounded-full bg-red-50 shadow-sm border border-red-100"
                    >
                        <Home className="w-5 h-5 text-[#e60012]" />
                    </button>
                </div>

                {/* CONTENT */}
                <div className="px-4 pb-8 space-y-3 flex-1">

                    <div className="mx-1 bg-white rounded-2xl shadow-md overflow-hidden border border-red-100">

                        {/* LIST */}
                        <div>
                            {visibleTxs.length === 0 && (
                                <p className="text-center text-[13px] text-gray-400 py-8">
                                    {t.redeem_noTransactions}
                                </p>
                            )}

                            {visibleTxs.map((tx, i) => {
                                const dateObj = new Date(tx.date);
                                const date = dateObj.toLocaleDateString();

                                const isRedeem = tx.type?.toLowerCase() === "redeem";
                                const isVoucher = tx.valueType?.toLowerCase() === "voucher";
                                const isPoint = tx.valueType?.toLowerCase() === "point";
                                // const type = tex?.type?.toLowerCase()
                                console.log(tx)

                                return (
                                    <div
                                        key={tx.id}
                                        className={`flex items-center justify-between px-4 py-3.5 transition-all ${i !== visibleTxs.length - 1
                                            ? "border-b border-red-50"
                                            : ""
                                            } hover:bg-red-50/30`}
                                    >
                                        <div className="flex items-center gap-3">

                                            {/* ICON */}
                                            <div
                                                className={`w-9 h-9 flex items-center justify-center rounded-full shadow-sm ${isRedeem
                                                    ? "bg-red-100 text-red-600"
                                                    : "bg-white border border-green-200 text-green-500"
                                                    }`}
                                            >
                                                {isRedeem ? (
                                                    <ArrowUpRight size={16} />
                                                ) : (
                                                    <ArrowDownLeft size={16} />
                                                )}
                                            </div>

                                            {/* TEXT */}
                                            <div>
                                                <p className="text-[13px] font-semibold text-[#111] leading-tight">
                                                    {isVoucher
                                                        ? "Earned Voucher"
                                                        : isRedeem
                                                            ? "Wallet Redeem"
                                                            : "Wallet Top-up"}
                                                </p>

                                                <p className="text-[11px] text-gray-500 leading-tight">
                                                    {tx.code}
                                                </p>

                                                <p className="text-[11px] text-gray-400 leading-tight">
                                                    {date}
                                                </p>
                                            </div>
                                        </div>

                                        {/* AMOUNT */}
                                        <p
                                            className={`text-[14px] font-bold ${isRedeem ? "text-red-600" : "text-green-600"
                                                }`}
                                        >
                                            {tx.amount
                                                ? `${isRedeem ? "-" : "+"}₹${tx.amount}`
                                                : ""}
                                        </p>
                                    </div>
                                );
                            })}

                            {/* LOADER */}
                            {hasMore && (
                                <div ref={loaderRef} className="flex justify-center py-4">
                                    <div className="w-5 h-5 border-2 border-red-500 border-t-transparent rounded-full animate-spin" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* FOOTER */}
                {/* <div className="w-full py-3 border-t">
                    <p className="text-[13px] text-red-600 uppercase text-center tracking-wide font-semibold">
                        © {new Date().getFullYear()} Consumer Journeys. All Rights Reserved.
                    </p>
                </div> */}
            </div>
        </div>
    );
};

export default RedeemCash;